import React from "react";
import PropTypes from "prop-types";

const TransactionDateRange = ({ transactions }) => {
  if (!transactions.length) return null;

  // Handle BigQuery date format which returns {value: "YYYY-MM-DD"}
  const dates = transactions.map((t) => {
    const dateString =
      typeof t.date === "object" && t.date?.value ? t.date.value : t.date;
    return new Date(dateString);
  });
  const minDate = new Date(Math.min(...dates));
  const maxDate = new Date(Math.max(...dates));

  const formatDate = (date) =>
    date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

  return (
    <p className="text-lg text-gray-500 mt-2">
      Showing transactions from{" "}
      <span className="font-medium">{formatDate(minDate)}</span> to{" "}
      <span className="font-medium">{formatDate(maxDate)}</span>
    </p>
  );
};

TransactionDateRange.propTypes = {
  transactions: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          value: PropTypes.string,
        }),
      ]).isRequired,
    }),
  ).isRequired,
};

export default TransactionDateRange;
